import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/content";

export const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="bg-white pb-14">
      <div className="max-w-[1000px] mx-auto px-4 lg:px-6">
        <div className="text-center mb-8">
          <h2 className="font-serif-display text-4xl md:text-5xl text-[var(--navy)]">
            Frequently Asked <span className="text-[var(--yellow-2)]">Questions</span>
          </h2>
          <p className="text-sm text-gray-500 mt-2">
            We help you prepare for your trip and ensure an effortless and
            enjoyable travel experience.
          </p>
        </div>

        <Accordion
          type="single"
          collapsible
          defaultValue="item-0"
          className="w-full space-y-3"
          data-testid="faq-accordion"
        >
          {FAQS.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border border-gray-200 rounded-md bg-[var(--soft)] data-[state=open]:bg-sky-50 data-[state=open]:border-sky-200 px-4"
            >
              <AccordionTrigger className="text-[var(--navy)] font-medium text-sm md:text-base py-4 hover:no-underline text-left">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 text-sm leading-relaxed pb-4">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
